import { render, staticRenderFns } from "./DestinationInventoryAssignment.vue?vue&type=template&id=1a786ff5&"
import script from "./DestinationInventoryAssignment.vue?vue&type=script&lang=js&"
export * from "./DestinationInventoryAssignment.vue?vue&type=script&lang=js&"
import style0 from "./DestinationInventoryAssignment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VIcon,VOverlay,VSelect})
